'use strict';

module.exports = '3.22.1';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 54
// module chunks = 0 1